import { render, staticRenderFns } from "./productionComponent.vue?vue&type=template&id=e48652d2"
import script from "./productionComponent.vue?vue&type=script&lang=js"
export * from "./productionComponent.vue?vue&type=script&lang=js"
import style0 from "./productionComponent.vue?vue&type=style&index=0&id=e48652d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports